export enum CachedQueryKeys {
  AppConfig = "appConfig",
  AppTheme = "appTheme",
  UserCart = "userCart",
  BrandAppConfigs = "brandAppConfigs",
  BrandClub = "brandClub",
  DTCProduct = "dtcProduct",
  SiteProduct = "siteProduct",
  UserProfile = "userProfile",
  ThemeSetup = "themeSetup",
}
